import { useTranslation } from 'react-i18next'
import { fmt } from './format'

function StepNumbers({ step }) {
  const { t } = useTranslation()
  if (step.coupling && step.effect != null) {
    return <span className="text-gray-600"> — {t(`systemView.methods.${step.method}`, { value: fmt(step.effect, 2) })}</span>
  }
  if (step.mover) {
    return <span className="text-gray-600"> — {t('systemView.loops.moverNumbers', { month: step.month, value: fmt(step.value), baseline: fmt(step.baseline) })}</span>
  }
  if (step.finding && step.value) {
    return <span className="text-gray-600"> — {t(`systemView.loops.findingValues.${step.value}`)}</span>
  }
  return null
}

/** VH-222: loops from curated templates, with the break point highlighted. */
export default function LoopsList({ loops = [] }) {
  const { t } = useTranslation()
  return (
    <section className="space-y-2" data-testid="loops-list">
      <h3 className="text-base font-semibold">{t('systemView.loops.title')}</h3>
      {loops.length === 0 ? (
        <p className="text-sm text-gray-600" data-testid="no-loops">{t('systemView.loops.none')}</p>
      ) : loops.map((loop) => (
        <article key={loop.code} className="border rounded-lg p-3 text-sm space-y-2" data-testid={`loop-${loop.code}`}>
          <div className="flex flex-wrap items-center justify-between gap-2">
            <p className="font-medium">{t(`systemView.loops.names.${loop.code}`)}</p>
            <span className="text-xs border rounded px-2 py-0.5">{t(`systemView.loops.kinds.${loop.kind}`)}</span>
          </div>
          <ol className="list-decimal ml-5 space-y-1">
            {loop.steps.map((s) => {
              const isBreak = loop.break_point?.step === s.number
              return (
                <li key={s.number} className={isBreak ? 'font-medium' : ''} data-break={String(isBreak)}>
                  {t(`loops.steps.${s.key}`)}
                  <StepNumbers step={s} />
                  {isBreak && <span className="ml-1 text-xs text-primary">{t('systemView.loops.breakHere')}</span>}
                </li>
              )
            })}
          </ol>
          {loop.break_point && <p className="text-gray-700" data-testid="break-reason">{t(loop.break_point.reason_key)}</p>}
          {loop.keep_reason_key && <p className="text-gray-700" data-testid="keep-reason">{t(loop.keep_reason_key)}</p>}
          {(loop.notes || []).map((n) => <p key={n} className="text-xs text-gray-600">{t(`systemView.loops.notes.${n}`)}</p>)}
        </article>
      ))}
    </section>
  )
}
